import { render, staticRenderFns } from "./CCRChannelList.vue?vue&type=template&id=f6f81f6a&scoped=true&"
import script from "./CCRChannelList.vue?vue&type=script&lang=js&"
export * from "./CCRChannelList.vue?vue&type=script&lang=js&"
import style0 from "./CCRChannelList.vue?vue&type=style&index=0&id=f6f81f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f81f6a",
  null
  
)

export default component.exports